<!--
Default tokens:
{
  '#': { pattern: /[0-9]/ },       // digits
  '@': { pattern: /[a-zA-Z]/ },    // letters
  '*': { pattern: /[a-zA-Z0-9]/ }, // letters & digits
}
Use ! before token to escape symbol. For example !# will render # instead of a digit.

Custom token example:
```
  <MaskedField mask="UUB" :customTokens="{ B: { pattern: /[A-B]/ }}" v-model="minhaVariavel" />
```

More details: https://beholdr.github.io/maska/v3/#/tokens
-->
<template>
  <input v-model="inputValueProxy" v-maska="maskOptions" type="text" class="form-control" />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { MaskInputOptions, MaskTokens } from 'maska';

export default defineComponent({
  name: 'MaskedField',
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: [String, Number, null] },
    /// é necessario se tiver usando um número com máscara em um formulário com HelperService.toFormData()
    isNumber: { type: Boolean, default: false },
    unmaskedModel: { type: Boolean, default: false },
    unmaskedAlphanumeric: { type: Boolean, default: false },
    mask: { type: [String, Array] as PropType<string | string[]>, required: true },
    customTokens: {
      type: Object as PropType<MaskTokens>,
      default: () => ({}) as MaskTokens
    }
  },
  computed: {
    // Propriedade computada para gerenciar a conversão entre string (input) e o tipo original
    inputValueProxy: {
      get(): string {
        return this.modelValue != null ? this.modelValue.toString() : '';
      },
      set(newValue: string) {
        if (this.unmaskedModel) {
          const unmasked = this.unmaskedAlphanumeric
            ? newValue.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
            : newValue.replace(/\D/g, '');
          if (this.isNumber) {
            const numeric = Number(unmasked);
            this.$emit('update:modelValue', isNaN(numeric) ? 0 : numeric);
          } else {
            this.$emit('update:modelValue', unmasked);
          }
        } else {
          if (this.isNumber) {
            const numeric = Number(newValue);
            this.$emit('update:modelValue', isNaN(numeric) ? 0 : numeric);
          } else {
            this.$emit('update:modelValue', newValue);
          }
        }
      }
    },
    maskOptions(): MaskInputOptions {
      return {
        mask: this.mask,
        tokens: {
          '%': { pattern: /[0-9]/, multiple: true },
          U: { pattern: /[a-zA-Z]/, transform: (v: string) => v.toUpperCase() },
          ...this.customTokens
        }
      };
    }
  }
});
</script>
